import { render, staticRenderFns } from "./Estimates.vue?vue&type=template&id=6c96483c&"
import script from "./Estimates.vue?vue&type=script&lang=js&"
export * from "./Estimates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports